/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  resetTour(userIds) {
    return axios.post(`${this.url}/reset_tour`, { user_ids: userIds });
  }

  tourStats() {
    return axios.get(`${this.url}/tour_stats`);
  }

  testPush(userId, kind = 'test') {
    return axios.post(`${this.url}/${userId}/test_push`, { kind });
  }
}

export default new Agents();
